
<script lang="ts" setup>

import { defineComponent, watchEffect ,onMounted, reactive} from "vue";
import {useRoute} from "vue-router";
import stateStore from "./utils/store";
import storeControle from "./utils/storeControle";
import {getToken} from "./utils/funcoes";

import LoginCliente from "./pages/cliente/Login.vue";

const stateStoreInstance = stateStore;
const route = useRoute();

var controle = reactive({
  rota: ""
})

onMounted(()=> {
    console.log("montando...");
    document.body.classList.add("bg-body-secondary");
    storeControle.token = getToken();
})

watchEffect(async () => {
  if (stateStoreInstance.open) {
      document.body.classList.remove("sidebar-show");
      document.body.classList.add("sidebar-hide");
    } else {
      document.body.classList.remove("sidebar-hide");
      document.body.classList.add("sidebar-show");
  }
})

function getTokenCliente() {
  const x = localStorage.getItem("clienteToken");

  if (x != null) {
   return x;
  }
  return "";
}

</script>

<template>

    <div class="container" >
      <router-view/>
    </div>

</template>
